
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Sinister } from '../../../../../typescript/sinisters/sinisterInfo';
import NoteForm from '../../../../../core/components/Notes/NoteForm.vue';
import { Note } from '../../../../../typescript/notes/notes';
import { ItemWithSinistersApi } from '../../../../../core/api/ItemWithSinistersApi';
import { enrichNotesWithClassificationNames } from '../../../../../samplings/enrich-notes';

@Component({
  components: {
    NoteForm,
  },
})
export default class InspectionNotes extends Vue {
  @Prop({ required: true }) sinister!: Sinister;
  @Prop({ type: Boolean, default: false }) showSamplingLabels!: boolean;
  @Prop({ default: () => ({}) }) classificationNames!: Record<number, string>;
  @Prop({ default: () => ({}) }) classificationColors!: Record<number, string>;
  @Prop({ default: null }) selectedNoteId!: number | null;

  fetchNotes(): Promise<Note[]> {
    return ItemWithSinistersApi.getSinisterNotes(this.sinister.id)
      .then(res => {
        const notes = res.ranch_notes || [];
        const enriched = this.showSamplingLabels
          ? enrichNotesWithClassificationNames(
              notes,
              this.classificationNames,
              this.classificationColors
            )
          : notes;
        this.seeNotesInMap(enriched);
        return enriched;
      });
  }

  @Emit()
  seeNotesInMap(notes: Note[]) {}

  addNote(note: Note) {
    return ItemWithSinistersApi.postNote(this.sinister.id, note);
  }

  updateNote(note: Note) {
    return ItemWithSinistersApi.patchNote(note);
  }

  deleteNote(note: Note) {
    return ItemWithSinistersApi.deleteNote(note.id as number);
  }
}
